import React, { useState, useEffect } from "react";
import styles from "../../assets/scss/Ledger/Ledgertable.module.scss";
import Pagination from "../../Components/Common/Pagination";
import { FaArrowRightToBracket } from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetPayableLedgerQuery } from "../../slices/admin/admin";
import { capitalize } from "../../utils/capitalize";

const PayableLedger = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [search, setSearch] = useState("");
    const [fromAmount, setFromAmount] = useState("");
    const [toAmount, setToAmount] = useState("");

    const navigate = useNavigate();
    const location = useLocation();

    // --- API Integration ---
    const offset = currentPage
    const { data, isLoading, isError, refetch } = useGetPayableLedgerQuery({
        search,
        fromAmount,
        toAmount,
        offset,
        limit,
    });

    const clearFilters = () => {
        setSearch("");
        setFromAmount("");
        setToAmount("");
        setCurrentPage(1);
        refetch();
    };

    return (
        <div className={styles.PayableLedgerContainer}>
            {/* --- Filters --- */}
            <div className={styles.filterBar}>
                <input
                    type="text"
                    placeholder="Search..."
                    className={styles.searchInput}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
                <input
                    type="number"
                    placeholder="From Amount"
                    className={styles.searchInput}
                    value={fromAmount}
                    onChange={(e) => setFromAmount(e.target.value)}
                />
                <input
                    type="number"
                    placeholder="To Amount"
                    className={styles.searchInput}
                    value={toAmount}
                    onChange={(e) => setToAmount(e.target.value)}
                />
                <button className={styles.clearBtn} onClick={clearFilters}>
                    Clear All
                </button>
            </div>

            {/* --- Table --- */}
            <div className={styles.tableWrapper}>
                <table>
                    <thead>
                        <tr>
                            <th>Customer Name</th>
                            <th>Org Name</th>
                            <th>Phone</th>
                            <th>Pending Credit</th>
                            <th>Debit Balance</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan="6" className={styles.noData}>
                                    Loading...
                                </td>
                            </tr>
                        ) : isError ? (
                            <tr>
                                <td colSpan="6" className={styles.noData}>
                                    Error loading data
                                </td>
                            </tr>
                        ) : data?.customers?.length > 0 ? (
                            data.customers.map((item) => (
                                <tr key={item._id}>
                                    <td>{item.customer?.firstName ? capitalize(item.customer.firstName) : "-"}</td>
                                    <td>{item.storeName ? capitalize(item.storeName) : "-"}</td>
                                    <td className="notranslate">{item.customer?.phone || "-"}</td>
                                    <td className="notranslate">
                                        {item.totalCreditAmount > 0 ? (
                                            <span className={`${styles.status} ${styles.statusPending}`}>
                                                ₹ {item.totalCreditAmount}
                                            </span>
                                        ) : (
                                            `₹ ${item.totalCreditAmount || 0}`
                                        )}
                                    </td>
                                    <td className="notranslate">₹ {item.walletBalance || 0}</td>
                                    <td>
                                        <FaArrowRightToBracket
                                            //   onClick={() =>
                                            //     navigate(
                                            //       `/dashboard/PayableViewLadger?id=${item._id}&mode=view`
                                            //     )
                                            //   }
                                            onClick={() =>
                                                navigate(
                                                    `/dashboard/PayableViewLadger?id=${item._id}&mode=view&activeTab=payable`
                                                )
                                            }

                                            className={styles.icon}
                                        />
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className={styles.noData}>
                                    No journal entries found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* --- Pagination --- */}
            <div className={styles.paginationWrapper}>
                <Pagination
                    currentPage={currentPage}
                    totalPages={Math.ceil((data?.total || 0) / limit)}
                    onPageChange={setCurrentPage}
                />
                <select
                    className={styles.inputsbtn}
                    value={limit}
                    onChange={(e) => {
                        setLimit(Number(e.target.value));
                        setCurrentPage(1);
                    }}
                >
                    <option value={10}>10 rows</option>
                    <option value={25}>25 rows</option>
                    <option value={50}>50 rows</option>
                </select>
            </div>
        </div>
    );
};

export default PayableLedger;
